import { useMemo } from 'react';

import { getCmsOffersMapByCmsId } from 'state/loyalty/utils';

import { useAppliedOfferMetadata } from './use-applied-offer-metadata';

export const useLoyaltyOffersMap = () => {
  // When loyalty-service offers are enabled this contains only already-applied
  // offers; otherwise it is the full offer catalog. A not-yet-applied offer
  // missing from the enabled-path map is harmless: the add-to-cart flow trusts
  // One Menu's canonical `referenceId` when the offer is absent.
  const offers = useAppliedOfferMetadata();
  const cmsOffersMap = useMemo(() => getCmsOffersMapByCmsId(offers), [offers]);
  return cmsOffersMap;
};
